import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import {
  KeyboardArrowLeft,
} from '@material-ui/icons';
import {
  convertToRaw,
} from 'draft-js';
import {
  inject,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import * as Yup from 'yup';
import {
  FormField,
} from '../../components/GeneralCRUDComponent/FormFields/formFields';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import Spinner from '../../components/Spinner';
import {
  DefaultLanguage, getDropdownLanguagesList,
} from '../../constants/languages';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  DeglawyPortalContent, IDeglawyPortalContentStore,
} from '../../mobx-store/storeInterfaces/deglawyPortalContentInterface';
import classes from './addEditDeglawyPortalContent.module.scss';


interface IProps extends WithSnackbarProps {
  deglawyPortalContentStore: IDeglawyPortalContentStore;
  history: any;
  match: any;
}

interface IState {
  formFields: FormField[];
  loading: boolean;
  selectedLang: string;
  processing: boolean;
}

@inject('deglawyPortalContentStore')
class AddEditDeglawyPortalContent extends Component<IProps, IState> {
  isNew = false;

  deglawyPortalContentId = -1;

  pageTitle = '';

  deglawyContentFormTitle = '';

  deglawyContentSchema: any;

  submitButton: any;

  cancelButton: any;

  dropdownLanguages: {
    langList: {langCode: string; langValue: string} [];
    selectedLang: string;
    label: string;
    onChange(langCode: string): any;
  } | null;

  constructor(props: IProps) {
    super(props);
    if (this.props.match.params.id) {
      this.isNew = false;
      this.deglawyPortalContentId = this.props.match.params.id;
      this.pageTitle = translate('editDeglawyContentPageTitle', {
      });
    } else {
      this.isNew = true;
      this.pageTitle = translate('addDeglawyContentPageTitle', {
      });
    }
    this.initBranchSchema();
    this.initState();
    this.submitButton = this.getSubmitButton();
    this.cancelButton = this.getCancelButton();
    this.dropdownLanguages = this.getDropdownLanguages();
    this.deglawyContentFormTitle = translate('addDeglawyContentPageFormTitle', {
    });
  }

  initBranchSchema = () => {
    this.deglawyContentSchema = Yup.object().shape({
      title: Yup.string()
        .required('Required'),
      body: Yup.string()
        .required('Required'),
      headerImageUrl: Yup.string(),
    });
  };

  getFormFields = (): FormField[] => [
    {
      name: 'title',
      label: translate('addDeglawyContentPageFormKey', {
      }),
      type: 'text',
      filedType: 'InputField',
      value: (this.isNew ? '' : this.props.deglawyPortalContentStore.selectedDeglawyPortalContent.getTitle()),
      disabled: (!this.isNew),
    },
    {
      name: 'body',
      label: translate('addDeglawyContentPageFormBody', {
      }),
      filedType: 'RichTextField',
      value: (this.isNew ? null : this.parseToJson(this.props.deglawyPortalContentStore.selectedDeglawyPortalContent.getBody())),
    },
    {
      name: 'headerImageUrl',
      label: translate('addDeglawyContentPageFormImage', {
      }),
      filedType: 'GalleryField',
      isLimitToOneImage: true,
      accept: 'image/*',
      value: (this.isNew ? [] : this.props.deglawyPortalContentStore.selectedDeglawyPortalContent.getHeaderImage()),
      size: 200,
    },
  ];

  parseToJson = (body: string) => {
    try {
      return JSON.parse(body);
    } catch (error) {
      return null;
    }
  };

  initState = () => {
    this.state = {
      processing: false,
      selectedLang: DefaultLanguage,
      loading: !this.isNew,
      formFields: this.getFormFields(),
    };
  };

  getDeglawyContentFormValues = (values: any) => {
    const deglawyContent = new DeglawyPortalContent();
    deglawyContent.setBody(JSON.stringify(convertToRaw(values.body.getCurrentContent())));
    deglawyContent.setTitle(values.title);
    deglawyContent.setHeaderImage(values.headerImageUrl);
    deglawyContent.setId(this.deglawyPortalContentId);
    return deglawyContent;
  };

  handelSubmit = (values: any): void => {
    this.setState({
      processing: true,
    });
    if (!this.isNew) {
      const updatedDeglawyContent = this.getDeglawyContentFormValues(values);
      this.props.deglawyPortalContentStore.updateDeglawyContentById(updatedDeglawyContent, this.deglawyPortalContentId, this.state.selectedLang)
        .then(() => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
          }), 8000, 'success');
        }).catch((error) => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
          }), 8000, 'error');
        });
    }
  };

  handelCancel = (): void => {
    console.log('canceled');
    this.props.history.goBack();
  };

  getSubmitButton = () => ({
    title: (this.isNew ? 'Add' : 'Save Changes'),
    onSubmit: this.handelSubmit,
  });

  handelLanguageChange = (langCode: string) => {
    if (langCode !== this.state.selectedLang) {
      if (this.isNew) {
        this.setState({
          selectedLang: langCode,
        });
      } else {
        this.getDeglawyContent(langCode);
      }
    }
  };

  getDropdownLanguages = () => {
    if (this.isNew) {
      return null;
    }
    return {
      langList: getDropdownLanguagesList(),
      selectedLang: this.state.selectedLang,
      label: 'Select Languages',
      onChange: this.handelLanguageChange,
    };
  };

  getCancelButton = () => ({
    title: 'Cancel',
    onCancel: this.handelCancel,
  });

  updateStateWithDeglawyContentData = () => {
    const formFieldsWithData = this.getFormFields();
    this.setState({
      formFields: formFieldsWithData, loading: false,
    });
  };

  render() {
    return (
      <div className={classes.container}>
        <div className={classes.header}>
          <IconButton
            className={classes.backButton}
            onClick={() => this.props.history.goBack()}
            aria-label="Back"
          >
            <KeyboardArrowLeft />
          </IconButton>
          <Typography className={classes.title} variant="h6" gutterBottom>
            {this.pageTitle}
          </Typography>
        </div>
        <div className={classes.content}>
          {
            this.state.loading
              ? <Spinner />
              : (
                <GeneralFormComponent
                  dropdownLanguages={this.dropdownLanguages}
                  formTitle={this.deglawyContentFormTitle}
                  fields={this.state.formFields}
                  formSchema={this.deglawyContentSchema}
                  submitButton={this.submitButton}
                  cancelButton={this.cancelButton}
                  processing={this.state.processing}
                />
              )
          }
        </div>
      </div>
    );
  }

  componentDidMount() {
    if (!this.isNew) {
      this.getDeglawyContent(this.state.selectedLang);
    }
  }

  getDeglawyContent = (langCode: string) => {
    this.setState({
      loading: true,
    });
    this.props.deglawyPortalContentStore.getDeglawyContentById(this.deglawyPortalContentId, langCode)
      .then(() => {
        this.updateStateWithDeglawyContentData();
        this.dropdownLanguages!.selectedLang = langCode;
        this.setState({
          selectedLang: langCode,
        });
      }).catch(() => {
        this.setState({
          loading: false,
        });
      });
  };
}

export default AddEditDeglawyPortalContent;
